<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-lg-12">
        <h2>Editar Configuração de Dashboard</h2>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'dashboard' }">
              Dashboard
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'config-dashboard-index' }">
              Configurações de Dashboard
            </router-link>
          </li>
          <li class="active">
            <strong>Editar Configuração de Dashboard</strong>
          </li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content animated fadeInDown">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>Editar Configuração de Dashboard</h5>
        </div>
        <div class="ibox-content">
          <form @submit.prevent="submit()">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="dataInicio">Data de Início</label>
                  <Datepicker
                    :value="input.DataInicio"
                    placeholder="Data de Início"
                    @select="onSelectDataInicio"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Data Final</label>
                  <Datepicker
                    :value="input.DataFim"
                    placeholder="Data Final"
                    @select="onSelectDataFim"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="hr-line-dashed" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label>Localidade</label>
                <div
                  class="form-group"
                  :class="{ 'has-error': errors.has('Localidade') }"
                >
                  <label class="radio-inline">
                    <input
                      v-model="input.Localidade"
                      type="radio"
                      value="Estado"
                    />
                    Estado
                  </label>
                  <label class="radio-inline">
                    <input
                      v-model="input.Localidade"
                      type="radio"
                      value="Regiao"
                    />
                    Região
                  </label>
                  <label class="radio-inline">
                    <input
                      v-model="input.Localidade"
                      type="radio"
                      value="Cidade"
                    />
                    Cidade
                  </label>
                </div>
                <input
                  v-model="input.Localidade"
                  v-validate="'required'"
                  type="text"
                  hidden
                  name="Localidade"
                />
                <span v-if="errors.has('Localidade')" class="text-danger">
                  {{ errors.first('Localidade') }}
                </span>
              </div>
              <div
                v-if="input.Indicador && input.Indicador.TemRota"
                class="col-md-4"
              >
                <label>Localidade Destino</label>
                <div
                  class="form-group"
                  :class="{ 'has-error': errors.has('LocalidadeDestino') }"
                >
                  <label class="radio-inline">
                    <input
                      v-model="input.LocalidadeDestino"
                      type="radio"
                      value="Estado"
                    />
                    Estado
                  </label>
                  <label class="radio-inline">
                    <input
                      v-model="input.LocalidadeDestino"
                      type="radio"
                      value="Regiao"
                    />
                    Região
                  </label>
                  <label class="radio-inline">
                    <input
                      v-model="input.LocalidadeDestino"
                      type="radio"
                      value="Cidade"
                    />
                    Cidade
                  </label>
                </div>
                <input
                  v-model="input.LocalidadeDestino"
                  v-validate="'required'"
                  type="text"
                  hidden
                  name="LocalidadeDestino"
                  data-vv-as="Localidade Destino"
                />
                <span
                  v-show="errors.has('LocalidadeDestino')"
                  class="text-danger"
                >
                  {{ errors.first('LocalidadeDestino') }}
                </span>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="hr-line-dashed" />
              </div>
            </div>
            <div class="row">
              <div v-if="input.Localidade === 'Estado'" class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('Estado') }"
                  class="form-group"
                >
                  <label>Estado</label>
                  <ResourceSelect
                    key="estado-input"
                    v-model="input.Estado"
                    v-validate="'required'"
                    data-vv-name="Estado"
                    endpoint="estado/seriehistorica"
                    request-method="POST"
                    :query-filters="{ ConfPainel: true }"
                    filters-in-body
                  />
                  <span v-show="errors.has('Estado')" class="text-danger">
                    {{ errors.first('Estado') }}
                  </span>
                </div>
              </div>
              <div v-if="input.Localidade === 'Regiao'" class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('Regiao') }"
                  class="form-group"
                >
                  <label>Região</label>
                  <ResourceSelect
                    key="regiao-input"
                    v-model="input.Regiao"
                    v-validate="'required'"
                    data-vv-name="Regiao"
                    data-vv-as="Região"
                    endpoint="regiao/seriehistorica"
                    request-method="POST"
                    :query-filters="{ ConfPainel: true }"
                    filters-in-body
                  />
                  <span v-show="errors.has('Regiao')" class="text-danger">
                    {{ errors.first('Regiao') }}
                  </span>
                </div>
              </div>
              <div v-if="input.Localidade === 'Cidade'" class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('Cidade') }"
                  class="form-group"
                >
                  <label>Cidade</label>
                  <ResourceSelect
                    key="cidade-input"
                    v-model="input.Cidade"
                    v-validate="'required'"
                    data-vv-name="Cidade"
                    endpoint="cidade/seriehistorica"
                    request-method="POST"
                    :query-filters="{ ConfPainel: true }"
                    filters-in-body
                  />
                  <span v-show="errors.has('Cidade')" class="text-danger">
                    {{ errors.first('Cidade') }}
                  </span>
                </div>
              </div>
              <div v-if="input.LocalidadeDestino === 'Estado'" class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('EstadoDestino') }"
                  class="form-group"
                >
                  <label>Estado Destino</label>
                  <ResourceSelect
                    key="estado-destino-input"
                    v-model="input.EstadoDestino"
                    v-validate="'required'"
                    data-vv-name="EstadoDestino"
                    data-vv-as="Estado Destino"
                    endpoint="estado/seriehistorica"
                    request-method="POST"
                    :query-filters="{ ConfPainel: true }"
                    filters-in-body
                  />
                  <span
                    v-show="errors.has('EstadoDestino')"
                    class="text-danger"
                  >
                    {{ errors.first('EstadoDestino') }}
                  </span>
                </div>
              </div>
              <div v-if="input.LocalidadeDestino === 'Regiao'" class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('RegiaoDestino') }"
                  class="form-group"
                >
                  <label>Região Destino</label>
                  <ResourceSelect
                    key="regiao-destino-input"
                    v-model="input.RegiaoDestino"
                    v-validate="'required'"
                    data-vv-name="RegiaoDestino"
                    data-vv-as="Região Destino"
                    endpoint="regiao/seriehistorica"
                    request-method="POST"
                    :query-filters="{ ConfPainel: true }"
                    filters-in-body
                  />
                  <span v-if="errors.has('RegiaoDestino')" class="text-danger">
                    {{ errors.first('RegiaoDestino') }}
                  </span>
                </div>
              </div>
              <div v-if="input.LocalidadeDestino === 'Cidade'" class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('CidadeDestino') }"
                  class="form-group"
                >
                  <label>Cidade Destino</label>
                  <ResourceSelect
                    key="cidade-destino-input"
                    v-model="input.CidadeDestino"
                    v-validate="'required'"
                    data-vv-name="CidadeDestino"
                    data-vv-as="Cidade Destino"
                    endpoint="cidade/seriehistorica"
                    request-method="POST"
                    :query-filters="{ ConfPainel: true }"
                    filters-in-body
                  />
                  <span v-if="errors.has('CidadeDestino')" class="text-danger">
                    {{ errors.first('CidadeDestino') }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="input.Localidade" class="row">
              <div class="col-md-12">
                <div class="hr-line-dashed" />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('Cadeia') }"
                  class="form-group"
                >
                  <label for="cadeia">Cadeia</label>
                  <ResourceSelect
                    v-validate="'required'"
                    :value="input.Cadeia"
                    data-vv-name="Cadeia"
                    endpoint="cadeia/seriehistorica"
                    request-method="POST"
                    :query-filters="{ ConfPainel: true }"
                    filters-in-body
                    @select="onChangeCadeia"
                  />
                  <span v-show="errors.has('Cadeia')" class="text-danger">
                    {{ errors.first('Cadeia') }}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('Grupo') }"
                  class="form-group"
                >
                  <label for="grupo">Grupo de Indicadores</label>
                  <ResourceSelect
                    :value="input.Grupo"
                    :disabled="!input.Cadeia"
                    :query-filters="selectGrupoFilters"
                    label-key="Descricao"
                    endpoint="indicadorgrupo/seriehistorica"
                    request-method="POST"
                    filters-in-body
                    @select="onChangeGrupo"
                  />
                  <span v-show="errors.has('Grupo')" class="text-danger">
                    {{ errors.first('Grupo') }}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  :class="{ 'has-error': errors.has('Indicador') }"
                  class="form-group"
                >
                  <label for="indicador">Indicador Final</label>
                  <ResourceSelect
                    v-model="input.Indicador"
                    v-validate="'required'"
                    data-vv-name="Indicador"
                    :disable="!input.Cadeia"
                    :query-filters="selectIndicadorFilters"
                    label-key="IndicadorNome"
                    endpoint="indicadorfinal/seriehistorica"
                    request-method="POST"
                    filters-in-body
                  />
                  <span v-show="errors.has('Indicador')" class="text-danger">
                    {{ errors.first('Indicador') }}
                  </span>
                </div>
              </div>
            </div>
            <div v-if="input.Indicador && input.Indicador.TemSafra">
              <div class="row">
                <div class="col-md-12">
                  <div class="hr-line-dashed" />
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div
                    :class="{ 'has-error': errors.has('Safra') }"
                    class="form-group"
                  >
                    <label for="safra">Safra</label>
                    <ResourceSelect
                      v-model="input.Safra"
                      v-validate="'required'"
                      data-vv-name="Safra"
                      label-key="Descricao"
                      endpoint="safra/seriehistorica"
                      :query-filters="{ ConfPainel: true }"
                      request-method="POST"
                      filters-in-body
                    />
                    <span v-show="errors.has('Safra')" class="text-danger">
                      {{ errors.first('Safra') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <router-link
                    :to="{ name: 'config-dashboard-index' }"
                    class="btn btn-white"
                  >
                    Voltar
                  </router-link>
                  <button type="submit" class="btn btn-primary">
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '../../store'
import Datepicker from '../../components/Datepicker'
import hideLoading from '../../lib/hideLoading'
import { mapGetters, mapActions } from 'vuex'
import ResourceSelect from '../../components/ResourceSelect'

export default {
  name: 'ConfigDashboardEdit',
  components: {
    Datepicker,
    ResourceSelect
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch('configDashboard/edit/requestData', {
      id: to.params.id
    })
    next()
  },
  created() {
    document.title = 'Editar Configuração de Dashboard - IMEA'
    this.input = this.dataForEdit
    this.$analytics.setCurrentScreen(document.title)
    this.$analytics.logEvent('screen_view')
  },
  mounted() {
    hideLoading()
  },
  computed: {
    ...mapGetters('configDashboard/edit', ['dataForEdit']),
    selectGrupoFilters() {
      const input = this.input
      const cadeia = input.Cadeia && input.Cadeia.Id

      return { cadeia: [cadeia], ConfPainel: true }
    },
    selectIndicadorFilters() {
      const input = this.input
      const cadeia = input.Cadeia && input.Cadeia.Id
      const grupo = input.Grupo && input.Grupo.Id

      return {
        cadeia: [cadeia],
        grupo: [grupo],
        ConfPainel: true
      }
    }
  },
  watch: {
    'input.Localidade'(_, oldValue) {
      if (!oldValue) return

      this.input.Cidade = undefined
      this.input.Estado = undefined
      this.input.Regiao = undefined
    },
    'input.LocalidadeDestino'(_, oldValue) {
      if (!oldValue) return

      this.input.CidadeDestino = undefined
      this.input.EstadoDestino = undefined
      this.input.RegiaoDestino = undefined
    }
  },
  methods: {
    onSelectDataInicio(value) {
      this.$set(
        this.input,
        'DataInicio',
        value ? value.toISOString() : undefined
      )
    },
    onSelectDataFim(value) {
      this.$set(this.input, 'DataFim', value ? value.toISOString() : undefined)
    },
    onChangeCadeia(Cadeia) {
      this.$set(this.input, 'Cadeia', Cadeia)
      this.input.Grupo = undefined
      this.input.Indicador = undefined
    },
    onChangeGrupo(Grupo) {
      this.$set(this.input, 'Grupo', Grupo)
      this.input.Indicador = undefined
    },
    async submit() {
      const isValid = await this.$validator.validateScopes()

      if (!isValid) return

      const input = this.input

      const data = {
        Id: this.$route.params.id,
        DataInicio: input.DataInicio,
        DataFim: input.DataFim,
        EstadoId: input.Estado && input.Estado.Id,
        RegiaoId: input.Regiao && input.Regiao.Id,
        CidadeId: input.Cidade && input.Cidade.Id,
        EstadoDestinoId: input.EstadoDestino && input.EstadoDestino.Id,
        RegiaoDestinoId: input.RegiaoDestino && input.RegiaoDestino.Id,
        CidadeDestinoId: input.CidadeDestino && input.CidadeDestino.Id,
        CadeiaId: input.Cadeia.Id,
        IndicadorGrupoId: input.Grupo && input.Grupo.Id,
        indicadorFinalId: input.Indicador.Id,
        SafraId: input.Safra && input.Safra.Id
      }
      await this.submitData(data)

      this.$router.push({ name: 'config-dashboard-index' })
    },
    ...mapActions('configDashboard/edit', ['submitData'])
  },
  data() {
    return {
      input: {}
    }
  }
}
</script>
